
export default function PRReportPackageController(
  $q,
  $rootScope,
  $scope,
  loaderService,
  reportsDataService,
  alerts,
  confirmDialog,
  editReportPackageDialog,
  ssDialogService
) {
  const vm = this;
  vm.isExpanded = false;
  vm.hasData = false;

  vm.canDownloadItemPackage = vm.reportPackage.hasReportPackage;

  vm.handleExpandReportPackage = handleExpandReportPackage;

  vm.handleEditPackage = handleEditPackage;
  vm.handleGeneratePackage = handleGeneratePackage;
  vm.handleDownloadPackage = _handleDownloadPackage;
  vm.handleDeletePackage = handleDeletePackage;

  vm.documentAttached = _documentAttached;

  _initEventListeners();

  /** ********************************************
   * Event Handlers
   */

  function handleExpandReportPackage() {
    if (vm.hasData) {
      vm.isExpanded = !vm.isExpanded;
    } else if (vm.reportPackage.numberOfAttachedReports > 0) {
      loaderService.showViewLoader = false;
      vm.isExpanded = !vm.isExpanded;
      vm.hasData = true;
    }
  }

  function handleEditPackage($event) {
    return _showEditReportPackageDialog($event);
  }

  function handleGeneratePackage() {
    return reportsDataService.createPackageFileGenerationRequest(vm.reportPackage.reportPackageId).then(() => {
      alerts.success('The Report Package has been successfully requested. '
        + 'You will receive an email notification when the file generation is complete.');
    });
  }

  function _handleDownloadPackage() {
    alerts.success('Download Package has been requested. Package download will start momentarily.');
    reportsDataService.downloadPackage(vm.reportPackage.reportPackageId).then((packageResponse) => {
      reportsDataService.download(packageResponse);
    });
  }

  function handleDeletePackage($event) {
    return _showDeleteDialog($event, {
      dialogTitle: 'Delete Report Package?',
      message: `Are you sure you want to delete Report Package "${vm.reportPackage.packageName}"?`,
      handleYesClick: handleConfirmDelete,
      handleNoClick: closeDeleteDialog,
    });
  }

  /** ********************************************
   * Private Functions
   */

  function _initEventListeners() {
    $scope.$on('reports.reportPackageUpdated', (event, opt) => {
      if (opt.reportPackageId === vm.reportPackage.reportPackageId) {
        _refreshReportAttachments();
      }
    });

    $scope.$on('reports.reportPackageReportDeleted', (event, opt) => {
      if (opt.reportPackageReport.reportPackageId === vm.reportPackage.reportPackageId) {
        _refreshReportAttachments();
      }
    });
  }

  function _documentAttached() {
    $rootScope.$broadcast('refreshReportPackage', { reportPackageId: vm.reportPackage.reportPackageId });
  }

  function _refreshReportAttachments() {
    const dfdRefresh = $q.defer();

    reportsDataService.getPackagedReportAttachments(vm.reportPackage.reportPackageId).then((response) => {
      vm.reportPackage.reportPackageReportInstances = [];
      if (response.data.recordCount > 0) {
        angular.extend(vm.reportPackage.reportPackageReportInstances, response.data.result);
      }

      if (response.data.recordCount !== vm.reportPackage.numberOfAttachedReports) {
        vm.reportPackage.numberOfAttachedReports = response.data.recordCount;

        if (vm.reportPackage.numberOfAttachedReports === 0) {
          vm.isExpanded = false;
        }
      }

      dfdRefresh.resolve();
    });
    return dfdRefresh.promise;
  }

  function _showDeleteDialog($event, locals) {
    ssDialogService.dialogs.reports.deleteReportPackageConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.deleteReportPackageConfirmDialog);
  }

  function _showEditReportPackageDialog($event) {
    ssDialogService.dialogs.reports.editReportPackageDialog = ssDialogService.alert(
      editReportPackageDialog.getOptions($event, {
        reportPackage: vm.reportPackage,
        attachCallback: vm.documentAttached,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.editReportPackageDialog);
  }

  function handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return reportsDataService.deleteReportPackage(vm.reportPackage.reportPackageId)
      .then(() => {
        alerts.success('The Report Package has been deleted successfully.');
        $rootScope.$broadcast('refreshReportPackages');
        return closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the Report Package.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function closeDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.deleteReportPackageConfirmDialog);
  }
}


PRReportPackageController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'loaderService',
  'reportsDataService',
  'alerts',
  'confirmDialog',
  'editReportPackageDialog',
  'ssDialogService',
];
